import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    document.title = 'Método AnsExpress';
  }, []);
  return <SalesPage data-id="element-0" />;
}